import React from 'react';
import cn from 'classnames';
import styles from './Checkbox.module.css';
import { ReactComponent as CheckIcon } from '../../../assets/Check.svg';

type CheckboxProps = {
    value: boolean;
    onChange?: (value: boolean) => void;
    ariaLabel?: string;
    className?: string;
};

const Checkbox = ({ value, onChange, ariaLabel, className }: CheckboxProps) => {
    return (
        <span
            role="checkbox"
            aria-label={ariaLabel}
            aria-checked={value}
            className={cn(styles.checkbox, className, { [styles.checked]: value })}
            onClick={() => onChange && onChange(!value)}
        >
            {value && <CheckIcon width={10} height={10} />}
        </span>
    );
};

export default Checkbox;
